import { useTranslation } from 'react-i18next'

export function OfflineScreen() {
  const { t } = useTranslation()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        padding: '40px 24px',
        textAlign: 'center',
        gap: '16px',
      }}
    >
      <span style={{ fontSize: '48px' }}>🌰</span>
      <p
        style={{
          fontSize: '18px',
          fontWeight: 500,
          color: 'hsl(var(--foreground))',
        }}
      >
        {t('common.offlineTitle')}
      </p>
      <p
        style={{
          fontSize: '15px',
          color: 'hsl(var(--muted-foreground))',
          maxWidth: '280px',
          lineHeight: 1.6,
        }}
      >
        {t('common.offlineSubtitle')}
      </p>
    </div>
  )
}
